// @ts-expect-error モジュール 'sweetalert' に型定義が無いため
import swal from 'sweetalert';
import JQueryView, { on } from '../../../../../../common/views/jqueryView';

export default class ShowView extends JQueryView {
  isPdfClicked: boolean;

  constructor(isPdfClicked: boolean) {
    super('.simple_form');
    this.isPdfClicked = isPdfClicked;
  }

  @on({ event: 'click', selector: '.pdf' })
  onClickPdf() {
    this.isPdfClicked = true;
  }

  @on({ event: 'click', selector: 'input[name="commit"]' })
  onSubmit() {
    if (!this.isPdfClicked) {
      swal({
        title: '契約締結前交付書面の内容をご確認ください',
        confirmButtonColor: '#2196F3',
        animation: false,
      });
      return false;
    } else {
      return true;
    }
  }
}
